<dialog #dialog class="modal" (click)="onBackdropClick($event)">
    <button type="button" class="modal__close" (click)="onCloseModal()">X</button>
    <div class="modal__content">
        <img class="modal__image" src="/assets/images/gif/register-success.gif"/>
        <div class="modal__highlight">
            <span class="modal__title">Cuenta creada con éxito</span>
        </div>
        <p class="modal__description">Por la creación de tu cuenta en PeruFc acabas de ganar 50 puntos. Sigue acumulando puntos para poder canjearlos por diversos premios.</p>
    </div>
</dialog>